<!-- A three-letter LCD avatar for list rows: the friend's first three
     characters on a scrap of classic glass. Decorative — the row beside it
     carries the name — so it is hidden from assistive tech. -->
<template>
  <span class="pm-lcd-chip" aria-hidden="true">{{ short }}</span>
</template>

<script setup>
import { computed } from 'vue';
import { graphemes } from '../pm/text.js';

const props = defineProps({
  text: { type: String, default: '' },
});

const short = computed(() => {
  const letters = graphemes(String(props.text || '').replace(/\s+/g, '').toUpperCase());
  return letters.slice(0, 3).join('') || '···';
});
</script>
